const UP = 38;
const DOWN = 40;
const ENTER = 13;
const ESC = 27;
const TAB = 9;
const SPACE = 32;
const F6 = 117;

export { UP, DOWN, ENTER, ESC, SPACE, TAB, F6 };

export const isKeyCodeOrKeyInList = (event, keyList) => {
  if (keyList.includes(event.keyCode) || keyList.includes(event.key)) {
    return true;
  }

  return false;
};
export const isKeyCodeOrKeyInListWithShift = (event, keyList) => {
  if (event.shiftKey && (keyList.includes(event.keyCode) || keyList.includes(event.key))) {
    return true;
  }
  return false;
};
export const isKeyCodeOrKeyInListWithCtrl = (event, keyList) => {
  if (event.ctrlKey && (keyList.includes(event.keyCode) || keyList.includes(event.key))) {
    return true;
  }
  return false;
};

/**
 * MIGRATION NOTE: We're gradually moving from KEY_CODES to KEY_NAMES because:
 *
 * 1. event.keyCode and event.which are officially deprecated in DOM spec
 *    https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
 *
 * 2. KEY_NAMES (using event.key) provides actual key meaning rather than physical position,
 *    making code more readable and intuitive (e.g. 'Escape' vs 27)
 *
 * 3. Better internationalization support - key codes vary across keyboard layouts
 *    while key names remain consistent to their meaning
 *
 * 4. Improves accessibility by focusing on key purpose rather than location
 *
 * 5. Reduces technical debt by aligning with current web standards (DOM Level 3 Events)
 *
 * For new code, please use KEY_NAMES. For existing code, please migrate when making
 * substantial changes to keyboard event handling.
 */
export const KEY_NAMES = {
  ESCAPE: 'Escape',
  ENTER: 'Enter',
  SPACE: ' ',
  DOWN: 'ArrowDown',
  UP: 'ArrowUp',
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight',
  TAB: 'Tab',
  F6: 'F6'
};
